const baseUrl2 = 'https://sistemavdv.com/sisv/externo/citas';

dayjs.locale('es-mx');
dayjs.extend(window.dayjs_plugin_localizedFormat)
dayjs.extend(window.dayjs_plugin_customParseFormat)
ko.validation.locale('es-ES');   

ko.validation.insertValidationMessage = function(element) {
    var span = document.createElement('SPAN');
    span.className = "validationMessage";
 
    var inputGroups = $(element).closest(".input-group");
    if (inputGroups.length > 0) {
        $(span).insertAfter(inputGroups);
    } else {
        element.parentNode.insertBefore(span, element.nextSibling);
    }
    return span;
};
const fnValidarTel= function(val){
  	if (val == '')
      	return true;
  
  	if (val.startsWith('0') || val.startsWith('1'))	
      	return false;
  
  	let valLimpio = val.replace(/\s/g, '');
  	let compRgx = /^\d{10}$/;
  	return compRgx.test(valLimpio);
}


const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

const ViewBag = function () {
    var data = {
        listaEstados2: [],
        listaPreguntas: [],
        urlParams: {
          iC: parseInt(params.iC, 10),
          iS: parseInt(params.iS, 10),
          iE: parseInt(params.iE, 10)
        },
        listaSexos: [
            { Id: 1, Descripcion: 'Hombre' },
            { Id: 2, Descripcion: 'Mujer' },
            { Id: 3, Descripcion: 'Prefiero no decirlo' },
        ],
        geoSettings: {
            enableHighAccuracy: true,
            maximumAge        : 30000,
            timeout           : 20000
        },
    };

    return data;
}();

var appVM2 = function () {

    var entidad = {
        Nombres: ko.observable('').extend({ required: true }),
        Apellidos: ko.observable('').extend({ required: true }),
        FechaNacimiento: ko.observable('').extend({ required: false }),
        Sexo: ko.observable('').extend({ required: true }),
        Telefono: ko.observable('').extend({ required: false, minLength: 10, maxLength: 12,  }).extend({validation: { validator: function (val){ return fnValidarTel(val)}, message: 'Introduzca un número de teléfono válido' } }),
        Celular: ko.observable('').extend({ required: true, minLength: 10, maxLength: 12, }).extend({validation: { validator: function (val){ return fnValidarTel(val)}, message: 'Introduzca un número de teléfono válido' } }),
        CorreoElectronico: ko.observable('').extend({ required: false, email: true }),
        IdSucursal: ko.observable(0).extend({ required: true }),
        FechaCita: ko.observable('').extend({ required: true }),
        UrlGoogleCalendar: ko.observable(''),
        UrlArchivoIcal: ko.observable(''),
        IdCita: ko.observable(0),
        FolioAlfa: ko.observable(''),
    };

    var entidadesValidar = ko.observableArray([entidad]);

    var vm = {
        tabActual: ko.observable(0),
        diasConsulta: ko.observable(0),
        entidad: entidad,
        entidadPreguntas: [],
        entidadSucursal: ko.observable(undefined),
        checkCovid: ko.observable(false),
        erroresValidacion: ko.validation.group(entidadesValidar, { deep: true }),
        filtroEstadoId: ko.observable(0),
        filtroCiudadId: ko.observable(0),
        filtroCiudadDescripcion: ko.observable(''),
        filtroSucursalId: ko.observable(0),
        filtroFechaCita: ko.observable(),

        listaSucursales2: ko.observableArray([]),
        listaCiudades2: ko.observableArray([]),
        listaEstados2: ko.observableArray([]),
        listaSexos: ko.observableArray([]),
        inicio: inicio,
        despuesBind: despuesBind,
        seleccionarPeriodo: seleccionarPeriodo,
        guardar: guardar,
        getPreguntas: getPreguntas,
        getEstados: getEstados,
        getCiudades: getCiudades,
        getSucursales: getSucursales,
        getSucursal: getSucursal,
        mostrarTab: mostrarTab,
        navegar: navegar,
    };

    function inicio() {
        vm.listaSexos(ViewBag.listaSexos);

        return $.when(
            appVM2.getEstados().done(function (d) { console.log(d); appVM2.listaEstados2(d.data); }),
            appVM2.getPreguntas().done(function (d) {
                console.log(d);
                ViewBag.listaPreguntas = d.data;
                vm.entidadPreguntas = ko.utils.arrayMap(ViewBag.listaPreguntas, function (item) {
                    return ko.mapping.fromJS(item)
                });
            })).promise();
    }


    function despuesBind() {
     
      	let idC = (ViewBag.urlParams.iC || 0)
        let idE = (ViewBag.urlParams.iE || 0)
        let idS = (ViewBag.urlParams.iS || 0)
        
        var evt =document.createEvent('UIEvents');
      	evt.initUIEvent('resize', true, false, window, 0);
      	window.dispatchEvent(evt);
        
      	vm.filtroEstadoId(idE);
       $('.ico-close').fadeIn(700);
        if (idC > 0){
        	appVM2.getCiudades().done(function (d) {
              appVM2.listaCiudades2(d.data); 
              appVM2.filtroCiudadId(idC); 
              if (idS > 0){
                appVM2.getSucursales().done(function (d) {                  
                    appVM2.listaSucursales2(d.data); 
                    appVM2.filtroSucursalId(idS);
                    vm.getSucursal().done(function (d) {
                        vm.entidadSucursal(ko.mapping.fromJS(d.data));
                        vm.entidad.IdSucursal(vm.filtroSucursalId());
                    });
                });
            }
              
            });
        }
    
        console.log('despuesbind');
        vm.erroresValidacion.showAllMessages(false);

        if (window.screen.availWidth < 420) {
            appVM2.diasConsulta(5);
        } else {
            appVM2.diasConsulta(5);
        }
        
        vm.filtroFechaCita(dayjs().format('DD/MM/YYYY'));

        $("#precarga").fadeOut(500, function () {
            $("#rw-navegacion").fadeIn(500);
            mostrarTab(vm.tabActual());
        });
      
        $('#fCelular').cleave({ phone: true, phoneRegionCode: 'MX' });
        $('#fTelefono').cleave({ phone: true, phoneRegionCode: 'MX' });
      
      
      	$('#fFechaNac').cleave({date: true, delimiter: '/', datePattern: ['d', 'm', 'Y']});
      	$('#fSemanaSelector').cleave({date: true, delimiter: '/', datePattern: ['d', 'm', 'Y']});
	
      
        vm.filtroEstadoId.subscribe(function (e) {
            appVM2.entidad.IdSucursal(undefined);
            appVM2.filtroCiudadId(undefined);
          	appVM2.filtroSucursalId(undefined);
   
            if (vm.filtroEstadoId() > 0) {
                appVM2.getCiudades().done(function (d) { console.log(d); appVM2.listaCiudades2(d.data); });
            } else {
             	appVM2.listaCiudades2([]);
            }
        });

        vm.filtroCiudadId.subscribe(function (e) {
            appVM2.entidad.IdSucursal(undefined);
            appVM2.filtroSucursalId(undefined);
            if (appVM2.filtroCiudadId() > 0) {
                appVM2.getSucursales().done(function (d) { console.log(d); appVM2.listaSucursales2(d.data); })
            } else {
             	appVM2.listaSucursales2([]);
              	appVM2.filtroSucursalId(undefined);
              	appVM2.entidad.IdSucursal(undefined);
            }
        });

        vm.filtroSucursalId.subscribe(function (e) {
          		appVM2.entidad.IdSucursal(undefined);
          		appVM2.entidad.FechaCita('');
          
          
            if (appVM2.filtroSucursalId() > 0) {
                vm.getSucursal().done(function (d) {
                    vm.entidadSucursal(ko.mapping.fromJS(d.data));
                    vm.entidad.IdSucursal(vm.filtroSucursalId());
                });
            } else {
             	appVM2.entidadSucursal(undefined); 
            }
        });

        vm.filtroFechaCita.subscribe(function (e) {
            if (appVM2.filtroSucursalId() > 0 && dayjs(vm.filtroFechaCita(), 'DD/MM/YYYY').isValid()) {
                vm.getSucursal().done(function (d) {
                    appVM2.entidadSucursal(ko.mapping.fromJS(d.data));
                    appVM2.entidad.IdSucursal(vm.filtroSucursalId());
                });
            } else {
                appVM2.entidadSucursal(undefined);
                appVM2.entidad.IdSucursal(undefined);
            }
        });

        vm.diasConsulta.subscribe(function (e) {
            if (vm.filtroSucursalId() > 0) {
                vm.getSucursal().done(function (d) {
                    vm.entidadSucursal(ko.mapping.fromJS(d.data));
                    vm.entidad.IdSucursal(vm.filtroSucursalId());
                });
            } else {
                appVM2.entidad.IdSucursal(undefined);
                appVM2.entidadSucursal(undefined);
            }
        })
    }

    function seleccionarPeriodo(item, e) {
        console.log(item);
        if (item.IdCita() > 0) {
            alert('Ya hay una cita reservada en este espacio. Seleccione otro.');
            return;
        } else if (item.IdCita() < 0) {
            alert('No puede agendar una cita en este espacio debido a que pertenece a una fecha/hora anterior al actual.');
            return;
        } else {
            vm.entidad.FechaCita(item.Espacio());
            $('.item-horario').removeClass('seleccion');
            $(e.target).addClass('seleccion');
        }
    }

    function guardar() {
        $("#precarga").fadeIn(500, function () {
            console.log('entró guardar');
            if (!vm.entidad.IdSucursal() > 0) {
              
            	if (!vm.filtroEstadoId() > 0){
              		alert("Por favor, selecciona un estado");
                	mostrarTab(0);
                	return;   
              	} else if (!vm.filtroCiudadId() > 0){
	              	alert("Por favor, selecciona una ciudad");
    	            mostrarTab(0);
        	        return;
            	} else {
                	alert('Por favor, selecciona una sucursal para tu cita');
                	mostrarTab(0);
                	return;	
                }
            }

            if (vm.entidad.FechaCita() == '' || vm.entidad.FechaCita() == undefined) {
                alert('No has seleccionado fecha y hora para la cita');
                mostrarTab(0);
                vm.erroresValidacion.showAllMessages();
                return;
            }

            if (vm.erroresValidacion().length != 0) {
                alert('Hay datos requeridos que no has proporcionado.\nFavor de registrar los datos faltantes');
                mostrarTab(0);
                vm.erroresValidacion.showAllMessages();
                return;
            }
            let entityPreguntas = ko.mapping.toJS(vm.entidadPreguntas);
            let entity = {
                Cliente: {
                    Nombre: vm.entidad.Nombres(),
                    Apellidos: vm.entidad.Apellidos(),
                    Telefono: vm.entidad.Telefono(),
                    Celular: vm.entidad.Celular(),
                    Email: vm.entidad.CorreoElectronico(),
                    FechaNacimiento: vm.entidad.FechaNacimiento(),
                    Sexo: vm.entidad.Sexo(),
                },
                FechaCita: vm.entidad.FechaCita(),
                SucursalId: vm.entidad.IdSucursal(),
                PreguntasPerfilamiento: entityPreguntas
            };
            /*if(vm.entidad.Nombres() == 'Mindtec Prueba'){
              console.log("asd");
                    let mensajeError = '<p class="fw-bold text-center text-danger">d.mensaje</p>';
              $('#msj-error').html('Ocurrió un error procesando tu solicitud. Por favor, intentalo nuevamente.</br>Lamentamos las molestias.</br>' + mensajeError);
                    
                mostrarTab(2);
              return;
            }*/
            $.ajax({
                url: baseUrl2 + '/RegistrarCita',
                method: 'POST',
                data: { cita: entity },
            }).done(function (d) {
                if (d.exito == true) {
                  
                    vm.entidad.IdCita(d.data.Id);
                    vm.entidad.FolioAlfa(d.data.FolioAlfa);
                  
                    mostrarTab(2)
                } else {
                  //alert("3 exito: false");
                    let mensajeError = "";
                    if (d.mensaje.length > 0){
                       mensajeError = '<p class="fw-bold text-center text-danger">' + d.mensaje +'</p>';
                    }
                    $('#msj-error').html('Ocurrió un error procesando tu solicitud. Por favor, intentalo nuevamente.</br>Lamentamos las molestias.</br>' + mensajeError);
                    vm.mostrarTab(2)
                    return;
                }
            }).fail(function (d) {
                $('#msj-error').html('Ocurrió un error procesando tu solicitud. Por favor, intentalo nuevamente.</br>Lamentamos las molestias.');
              	vm.mostrarTab(2)
                console.error(d);
            });
        });
    }

    function getPreguntas() {
        let data;

        return $.ajax({
            url: baseUrl2 + '/GetPreguntas',
            method: 'POST'
        }).done(function (d) { data = d; return data; });
    }

    function getEstados() {
        let data;

        return $.ajax({
            url: baseUrl2 + '/GetEstadosRep',
            method: 'POST'
        }).done(function (d) { data = d; return data; });
    }

    function getSucursales() {
        let data;

        return $.ajax({
            url: baseUrl2 + '/GetSucursalesPorCiudad',
            method: 'POST',
            data: {
                Ciudad: vm.filtroCiudadId()
            }
        }).done(function (d) { data = d; return data; });
    }

    function getCiudades() {
        let data;

        return $.ajax({
            url: baseUrl2 + '/GetCiudades',
            method: 'POST',
            data: {
                IdEstadoRepublica: vm.filtroEstadoId()
            }
        }).done(function (d) { data = d; return data; });
    }

    function getSucursal() {
        let data;
        $("#ajax-loader").fadeIn(100);
        return $.ajax({
            url: baseUrl2 + '/GetInfoSucursal',
            method: 'POST',
            data: {
                IdSucursal: vm.filtroSucursalId(),
                FechaInicio: vm.filtroFechaCita(),
                DiasPeriodo: vm.diasConsulta()
            }
        }).done(function (d) { data = d; $('#ajax-loader').fadeOut(100); return data; });
    }

    function mostrarTab(tab) {

        $("#precarga").fadeOut(500, function () { });
        vm.erroresValidacion.showAllMessages(false);

        var x = $(".tab");

        console.log('tab: ' + tab + ' , x.length: ' + x.length);

        if (tab == 0) {
            $("#btn-paso-atras").fadeOut();
        } else {
            $("#btn-paso-atras").fadeIn(500);
        }
        if (tab == 1) {
            $("#btn-paso-siguiente").html('<i class="fa fa-calendar-check-o"></i> Agendar Cita')
        } else {
            $("#btn-paso-siguiente").html('Siguiente <i class="fa fa-angle-double-right"></i>')
        }
        if (tab == (x.length - 1)) {
            $("#btn-paso-atras").fadeOut(250);
            $("#btn-paso-siguiente").fadeOut(250);
        }

        $(x[tab]).fadeIn(500);
    }

    function validarFecha() {

        var fechaActualMasSemana = new Date();
        var dias = 6; // Número de días a agregar
        fechaActualMasSemana.setDate(fechaActualMasSemana.getDate() + dias);
        
        var fechaCapturadaEnPantalla = $("#fSemanaSelector").val();
        var arregloFecha = entidad.FechaCita().split("-");
        var anio = arregloFecha[0];
        var mes = arregloFecha[1] - 1;
        var dia = arregloFecha[2].substring(0,2);
        var fechaCapturada = new Date(anio, mes, dia);
        
        if (fechaCapturada > fechaActualMasSemana)
        {
          //vm.erroresValidacion.showAllMessages();
          //alert("La fecha de la cita no puede ser mayor a siete días a partir del día de hoy ")
          return false;
        }      
      return true;
    }
    function navegar(tab) {
        console.log('entro navegar TA: ' + tab + '/' + vm.tabActual());
        if (tab > 0) {
            switch (vm.tabActual()) {
                case 0:
                    if (vm.entidad.IdSucursal() < 1 || vm.entidad.IdSucursal() == undefined) {
                          alert('Por favor, selecciona una sucursal para tu cita');
                          vm.erroresValidacion.showAllMessages();
                          return;	
                    }
                    if (!entidad.FechaCita.isValid()) {
                        vm.erroresValidacion.showAllMessages();
                        alert('No ha seleccionado una hora para la cita');
                        return;
                    }

                      if (validarFecha() == false){
                        vm.erroresValidacion.showAllMessages();
                        alert("La fecha de la cita no puede ser mayor a siete días a partir del día de hoy ");
                        return
                      }

                
                    break;
                case 1:
                    if (vm.erroresValidacion().length != 0) {
                        vm.erroresValidacion.showAllMessages();
                        alert('Algunos campos tienen información no válida.\nPor favor, verifica la información que has introducido.')
                        return;
                    }
                        vm.guardar();
                        $('#rw-navegacion').fadeOut(100);
                        var x = $(".tab");
                        $(x[vm.tabActual()]).fadeOut(250);
                        return;
                
                    break;
            }
        }

        var x = $(".tab");

        $(x[vm.tabActual()]).fadeOut(250, function () {
            vm.tabActual(vm.tabActual() + tab);
      
            if (vm.tabActual() >= x.length - 1) {
                $('#precarga').fadeIn(250);
                $('#rw-navegacion').fadeOut(100);
                vm.guardar();
                return false;
            } else {
                mostrarTab(vm.tabActual());
            }
        });
    }

    return vm;
}();

$(window).resize(function (e) {
    if (window.screen.availWidth < 420) {
        appVM2.diasConsulta(5);
    } else {
        appVM2.diasConsulta(5);
    }
});

$(function ($) {
  
  (function ($, window, undefined) {
    'use strict'

    $.fn.cleave = function (opts) {
        var defaults = { autoUnmask: false },
            options = $.extend(defaults, opts || {});
        return this.each(function () {
            var cleave = new Cleave('#' + this.id, options), $this = $(this);
            $this.data('cleave-auto-unmask', options['autoUnmask']);;
            $this.data('cleave', cleave)
        });
    }

    var origGetHook, origSetHook;
    if ($.valHooks.input) {
        origGetHook = $.valHooks.input.get;
        origSetHook = $.valHooks.input.set;
    } else {
        $.valHooks.input = {};
    }

    $.valHooks.input.get = function (el) {
        var $el = $(el), cleave = $el.data('cleave');
        if (cleave) {
            return $el.data('cleave-auto-unmask') ? cleave.getRawValue() : el.value;
        } else if (origGetHook) {
            return origGetHook(el);
        } else {
            return undefined;
        }
    }

    $.valHooks.input.set = function (el, val) {
        var $el = $(el), cleave = $el.data('cleave');
        if (cleave) {
            cleave.setRawValue(val);
            return $el;
        } else if (origSetHook) {
            return origSetHook(el);
        } else {
            return undefined;
        }
    }
})(jQuery, window);
	     
	$('#fFechaNac').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        locale: 'es-es',
        format: 'dd/mm/yyyy',
      	minDate: dayjs().subtract(150, 'year').startOf('day').toDate(),
      	
      	value: dayjs().subtract(5, 'year').startOf('day').toDate()
    });
    $('#fSemanaSelector').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        locale: 'es-es',
        format: 'dd/mm/yyyy',
      	minDate: dayjs().startOf('day').toDate(),
      	maxDate: dayjs().add(1, 'year').toDate()
        
    });

  $("#fSemanaSelector").blur(function() {
    appVM2.entidad.FechaCita('');
  });

    $.when(appVM2.inicio()).done(function () {
        console.log('inicio terminó');

        $("#app2").each(function (i, n) {
            console.log('aplicar binds')
            ko.applyBindings(appVM2, n);
        });
        appVM2.despuesBind();
    });
});
